export default __webpack_public_path__ + "assets/united-kingdom-flag.png";